export class ClasificacionDiligenciaModel{
    tipo: string;
    subTipo: string;
    sigla: string;
}
